var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg685483F49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.067,
    height: 64.098,
    viewBox: "0 0 64.067 64.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2790",
    "data-name": "Group 2790",
    transform: "translate(-12.967 -12.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2789",
    "data-name": "Group 2789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M51.306,47.114c-.034,0-.067-.008-.1-.01-1.175,0-1.917,1.045-1.917,2.35s.743,2.349,1.918,2.349a2.094,2.094,0,0,0,1.928-2.349A2.1,2.1,0,0,0,51.306,47.114Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M41.024,40.164h0a1.962,1.962,0,1,0-3.846,0,1.962,1.962,0,1,0,3.847,0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M39.562,44.825A4.363,4.363,0,0,0,43.6,40.164a4.479,4.479,0,0,0,.008-.456,4.51,4.51,0,0,0-9.007.455,4.359,4.359,0,0,0,4.5,4.669A4.267,4.267,0,0,0,39.562,44.825Zm-2.386-4.661a1.962,1.962,0,1,1,3.846,0h0a1.962,1.962,0,1,1-3.847,0Z",
    fill: "#efab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M49.779,35.776,37.971,53.85h2.55L52.33,35.776Z",
    fill: "#efab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M51.206,44.783a4.417,4.417,0,0,0-.463.009,4.355,4.355,0,0,0-4.026,4.66q-.006.169,0,.338a4.522,4.522,0,0,0,9-.793A4.364,4.364,0,0,0,51.206,44.783Zm1.928,4.669A2.094,2.094,0,0,1,51.206,51.8c-1.176,0-1.918-1.045-1.918-2.349s.743-2.35,1.917-2.35l.1.01A2.1,2.1,0,0,1,53.134,49.453Z",
    fill: "#efab00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M63.916,22.88a2.3,2.3,0,1,0,2.3,2.3A2.307,2.307,0,0,0,63.916,22.88Z",
    fill: "#efab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M76.912,38.987,73.538,19.048a3.216,3.216,0,0,0-2.615-2.614L50.981,13.059a8.2,8.2,0,0,0-1.337-.108,8.773,8.773,0,0,0-6.136,2.517L15.474,43.54a8.544,8.544,0,0,0,0,12.09l19.181,18.9a8.175,8.175,0,0,0,11.791.02L74.5,46.508a8.585,8.585,0,0,0,2.409-7.521Zm-4.563,5.36L44.288,72.39a5.124,5.124,0,0,1-7.481-.021L17.621,53.464a5.493,5.493,0,0,1,.011-7.767L45.664,17.625A5.613,5.613,0,0,1,49.6,16a5.5,5.5,0,0,1,.878.07l20.032,3.39L73.9,39.5A5.536,5.536,0,0,1,72.349,44.347Z",
    fill: "#efab00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg685483F49);
export default __webpack_public_path__ + "static/media/6.85483f49.36beeb0e97d63e94315b2d773b6d739f.svg";
export { ForwardRef as ReactComponent };